/* istanbul ignore file */

import {
  RESET_APP_STATE,
  TOGGLE_MODAL,
  RESET_NOTES_TAB,
  RESET_EMAIL_TAB,
  RESET_HISTROY_TAB,
  GET_SCHEDULE_VISITS_CARD,
  GET_SCHEDULE_VISITS_CARD_FALIURE,
  GET_PATIENT_INFO,
  GET_PATIENT_INFO_FALIURE,
  GET_PATIENT_INFO_LOADING,
  GET_SOAP_NOTE_INFO,
  GET_HEADER_INFO,
  GET_HEADER_INFO_FALIURE,
  GET_NOTES_FALIURE,
  GET_NOTES,
  RESET_PATIENT_INFO,
  GET_PRODUCT_INFO_FALIURE,
  GET_PRODUCT_INFO_LOADING,
  GET_PRODUCT_INFO,
  SET_PRODUCT_INFO,
  GET_PRODUCT_LIST_FALIURE,
  GET_PRODUCT_LIST,
  GET_QTY_BY_PRODUCT_ID_FALIURE,
  GET_QTY_BY_PRODUCT_ID,
  SAVE_PRODUCT_CHANGES_FALIURE,
  SAVE_PRODUCT_CHANGES,
  TOGGLE_PRODUCT_CHANGE_MODAL,
  GET_CONSULT_QUESTION_FALIURE,
  GET_CONSULT_QUESTION,
  GET_CONSULT_QUESTION_LOADING,
  GET_PENDING_FILES_CARD_FALIURE,
  GET_PENDING_FILES_CARD,
  GET_ORDER_NOTES_FAILURE,
  GET_ORDER_NOTES,
  GET_PATIENT_NOTES_FAILURE,
  GET_PATIENT_NOTES,
  GET_MEDICAL_ORDER_NOTES,
  GET_MEDICAL_ORDER_NOTES_FAILURE,
  GET_MEDICAL_PATIENT_NOTES,
  GET_MEDICAL_PATIENT_NOTES_FAILURE,
  SET_SELECTED_TAB,
  GET_EMAIL_FALIURE,
  GET_EMAIL,
  GET_HISTORY_FALIURE,
  GET_HISTORY,
  GET_EMAIL_TEMPLATE_FALIURE,
  GET_EMAIL_TEMPLATE,
  GET_EMAIL_TEMPLATE_V2,
  GET_EMAIL_TEMPLATE_V2_LOADING,
  GET_EMAIL_TEMPLATE_V2_FAILURE,
  SET_DENIAL_AND_SEND_EMAIL,
  GET_DENIAL_REASON_FAILURE,
  GET_DENIAL_REASON,
  GET_SUB_AND_EMAIL_FALIURE,
  GET_SUB_AND_EMAIL,
  GET_SUB_AND_EMAIL_V2,
  RESET_SUB_AND_EMAIL_V2,
  DENIAL_AND_EMAIL_FALIURE,
  DENIAL_AND_EMAIL,
  RESET_EMAIL_AND_DENY_DATA,
  GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_FAILURE,
  GET_APPROVE_AND_EMAIL_PRESCRIER_INFO,
  RESET_APPROVE_AND_MAIL_DATA,
  SET_APPROVE_AND_MAIL_DATA,
  SET_APPROVE_AND_MAIL_MAIN_DATA,
  HANDLE_GLOBAL_VALUE_CHANGE,
  GET_ORDER_AND_PRESCRIBER_FLAGS_FAILURE,

  GET_ORDER_AND_PRESCRIBER_FLAGS,
  GET_ORDER_AND_PRESCRIBER_FLAGS_LOADING,
  RESET_ORDER_AND_PRESCRIBER_FLAGS,

  VERIFY_PIN_FALIURE,
  VERIFY_PIN,
  TOGGLE_ERROR_MODAL,
  SET_MODAL_ALERT_OPEN,
  APPROVE_AND_MAIL_SUBMIT_FALIURE,
  APPROVE_AND_MAIL_SUBMIT,
  SET_START_VISIT,
  SET_START_VISIT_FALIURE,
  ADD_NOTE,
  ADD_SOAP_NOTE,
  ADD_NOTE_FAILURE,
  SET_ADD_NOTE,
  SET_ADD_SOAP_NOTE,
  RESET_ADD_NOTE_DATA,
  GET_REASONS_FALIURE,
  GET_REASONS,
  SEND_ORDER_TO_CS_FALIURE,
  SEND_ORDER_TO_CS,
  RESET_SEND_ORDER_TO_CS_DATA,
  SET_SEND_ORDER_TO_CS_DATA,
  GET_CALL_PATIENT_DETAILS,
  GET_CALL_PATIENT_DETAILS_FAILURE,
  SET_CALL_PATIENT_DETAILS,
  RESET_CALL_PATIENT_DETAILS,
  CALL_PATIENT_LOADING,
  CALL_PATIENT,
  CALL_PATIENT_FAILURE,
  SET_MODAL_TWILIO_ALERT_OPEN,
  RESET_EMAIL_PATIENT_DATA,
  EMAIL_PATIENT_DATA_FAILURE,
  EMAIL_PATIENT_DATA,
  EMAIL_PATIENT_DATA_LOADING,
  GET_TEXT_PATIENT_TEMPLATE_FALIURE,
  GET_TEXT_PATIENT_TEMPLATE,
  TEXT_PATIENT_FALIURE,
  TEXT_PATIENT,
  TEXT_PATIENT_LOADING,
  RESET_TEXT_PATIENT,
  POST_CALL_DETAILS_FALIURE,
  POST_CALL_DETAILS,
  CALL_END_FAILURE,
  CALL_END,
  GET_DOSESPOT_DATA_FALIURE,
  GET_DOSESPOT_DATA,
  RESET_DOSESPOT_DATA,
  LOG_ERROR_FALIURE,
  LOG_ERROR,
  CHECK_DOSESPOT_FALIURE,
  CHECK_DOSESPOT,
  LOG_OFF_FALIURE,
  LOG_OFF,
  UPLOAD_DOC_PATIENT,
  UPLOAD_DOC_PATIENT_FAILURE,
  SET_UPLOAD_DOCS,
  PDF_DOC,
  PDF_DOC_FAILURE,
  SET_UPLOAD_PDFS,
  PDF_AV_LOADING,
  PDF_AV,
  PDF_NAV,
  SET_SEARCH_ERROR,
  SET_SEARCH_DATA_FAILURE,
  SET_SEARCH_DATA,
  CLEAR_SEARCH_DATA,
  CALL_SUMMARY_REASONS,
  CALL_SUMMARY_REASONS_FAILURE,
  SET_CALL_SUMMARY,
  INSERT_CALL_SUMMARY,
  INSERT_CALL_SUMMARY_FAILURE,
  SET_FILTER_BY,
  GET_SCHEDULE_VISITS_CARD_LOADING,
  GET_PENDING_FILES_CARD_LOADING,
  GET_SCHEDULE_VISITS_CARD_CLEAR_API_STATUS,
  GET_PENDING_FILES_CARD_CLEAR_API_STATUS,
  GET_PDF_DATA,
  GET_PDF_DATA_FALIURE,
  SET_CMN_TEMPLATE_FORM_FIELD,
  SET_SOAP_NOTE_TEMPLATE,
  GET_SOAP_NOTE_TEMPLATES,
  GET_SOAP_NOTE_TEMPLATES_FAILURE,
  GET_SOAP_NOTE_TEMPLATES_LOADING,

  GET_PATIENT_UPLOADS,
  GET_PATIENT_UPLOADS_LOADING,
  GET_PATIENT_UPLOADS_FAILURE,

  ADD_DOSESPOT_PATIENT_PRESCRIPTION,
  ADD_DOSESPOT_PATIENT_PRESCRIPTION_LOADING,
  ADD_DOSESPOT_PATIENT_PRESCRIPTION_FAILURE,

  GET_CHANGE_PRODUCT_LIST,
  GET_CHANGE_PRODUCT_LIST_LOADING,
  GET_CHANGE_PRODUCT_LIST_FAILURE,
  RESET_CHANGE_PRODUCT_LIST,

  CHANGE_PRODUCT_LIST_RESPONSE,
  CHANGE_PRODUCT_LIST_ERROR,

  GET_ALL_SUB_AND_EMAIL,
  GET_ALL_SUB_AND_EMAIL_LOADING,
  GET_ALL_SUB_AND_EMAIL_FAILURE,
  ALL_SUB_AND_EMAIL_RESPONSE,
  ALL_SUB_AND_EMAIL_ERROR,

  GET_PRODUCT_INFO_V3_LOADING,
  GET_PRODUCT_INFO_V3,
  GET_PRODUCT_INFO_V3_FAILURE,
  CLEAR_PRODUCT_INFO_V3,

  GET_EMAIL_REASONS_LOADING,
  GET_EMAIL_REASONS,
  GET_EMAIL_REASONS_FAILURE,

  GET_PRODUCT_COST_LOADING,
  GET_PRODUCT_COST,
  GET_PRODUCT_COST_FAILURE,
  RESET_PRODUCT_COST,

  ADD_PRODUCT_LOADING,
  ADD_PRODUCT,
  ADD_PRODUCT_FAILURE,

  GET_APPROVE_EMAIL_TEMPLATE_V2,
  GET_APPROVE_EMAIL_TEMPLATE_V2_LOADING,
  GET_APPROVE_EMAIL_TEMPLATE_V2_FAILURE,

  GET_DENY_EMAIL_TEMPLATE_V2,
  GET_DENY_EMAIL_TEMPLATE_V2_LOADING,
  GET_DENY_EMAIL_TEMPLATE_V2_FAILURE,

  GET_SCHEDULE_EMAIL_TEMPLATE_V2,
  GET_SCHEDULE_EMAIL_TEMPLATE_V2_LOADING,
  GET_SCHEDULE_EMAIL_TEMPLATE_V2_FAILURE,

  SCHEDULE_VISIT,
  SCHEDULE_VISIT_LOADING,
  SCHEDULE_VISIT_FAILURE,
  REEST_SCHEDULE_VISIT,

  GET_SAVED_FLAGS,
  GET_SAVED_FLAGS_LOADING,
  GET_SAVED_FLAGS_FAILURE,
  RESET_SAVED_FLAGS,

  SAVE_FLAGS,
  SAVE_FLAGS_LOADING,
  SAVE_FLAGS_FAILURE,

  SAVE_EXTENDED_CONSULT,
  SAVE_EXTENDED_CONSULT_LOADING,
  SAVE_EXTENDED_CONSULT_FAILURE,
  GET_EMAIL_LOADING,
  GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_LOADING,
  GET_ORDER_NOTES_LOADING,
  GET_PATIENT_NOTES_LOADING,
  GET_MEDICAL_ORDER_NOTES_LOADING,
  GET_MEDICAL_PATIENT_NOTES_LOADING,

  REMOVE_ORDERS_FROM_LV,
  RESET_APPROVE_AND_EMAIL_PRESCRIER_INFO,
  RESET_PRODUCT_INFO,
  GET_HISTORY_LOADING,

  SEND_PASSWORD_RECOVERY_OTP,
  SENT_PASSWORD_RECOVERY_OTP,
  FAILD_TO_SEND_PASSWORD_RECOVERY_OTP,

  VALIDATE_PASSWORD_RECOVERY_OTP,
  VALIDATED_PASSWORD_RECOVERY_OTP,
  FAILED_TO_VALIDATE_PASSWORD_RECOVERY_OTP,

  RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP,
  PASSWORD_IS_RESET_USING_PASSWORD_RECOVERY_OTP,
  FAILED_TO_RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP,

  CLEAR_RECOVER_PASSWORD,
  GET_QTY_BY_PRODUCT_ID_LOADING,
  SAVE_PRODUCT_CHANGES_LOADING,
  SET_SEARCH_LOADING,
  GET_HEADER_INFO_LOADING,
  VALIDATE_TOKEN_FAILURE,
  VALIDATE_TOKEN,

  GET_TASKS_LOADING,
  GET_TASKS,
  GET_TASKS_FAILURE,
  GET_TASK_BY_ORDER_ID,
  GET_TASK_BY_ORDER_ID_LOADING,
  GET_TASK_BY_ORDER_ID_FAILURE,
  UPDATE_TASK,
  UPDATE_TASK_LOADING,
  UPDATE_TASK_FAILURE,

  GET_ICD10CODES_BY_ORDER_ID_LOADING,
  GET_ICD10CODES_BY_ORDER_ID,
  GET_ICD10CODES_BY_ORDER_ID_FAILURE,
  GET_ICD10CODES_BY_PATIENT_ID_LOADING,
  GET_ICD10CODES_BY_PATIENT_ID,
  GET_ICD10CODES_BY_PATIENT_ID_FAILURE,
  GET_ICD10CODES_BY_TERMS_LOADING,
  GET_ICD10CODES_BY_TERMS,
  GET_ICD10CODES_BY_TERMS_FAILURE,
  REMOVE_ICD10CODE_FROM_COLLECTION,
  ADD_ICD10CODES,
  ADD_ICD10CODES_FAILURE,
  ADD_ICD10CODES_LOADING,
  REMOVE_ICD10CODES,
  REMOVE_ICD10CODES_LOADING,
  REMOVE_ICD10CODES_FAILURE,
  CLEAR_ICD10CODES_BY_TERMS,
  CHANGE_PASSWORD_IN_PROGRESS,
  PASSWORD_IS_CHANGED,
  FAILED_TO_CHANGE_PASSWORD,
  CHANGE_PIN_IN_PROGRESS,
  PIN_IS_CHANGED,
  FAILED_TO_CHANGE_PIN,

  FETCHING_DOCTOR_PROFILE,
  DOCTOR_PROFILE_IS_FETCHED,
  FAILED_TO_FETCH_DOCTOR_PROFILE,

  FETCHING_DOCTOR_WEEKLY_SCHEDULE,
  DOCTOR_WEEKLY_SCHEDULE_IS_FETCHED,
  FAILED_TO_FETCH_DOCTOR_WEEKLY_SCHEDULE,
  SET_DOCTOR_WEEKLY_SCHEDULE_DATA,
  UPDATE_DOCTOR_WEEKLY_SCHEDULE_LOADING,
  UPDATE_DOCTOR_WEEKLY_SCHEDULE,
  UPDATE_DOCTOR_WEEKLY_SCHEDULE_FAILURE,
  REMOVE_DOCTOR_WEEKLY_SCHEDULE_LOADING,
  REMOVE_DOCTOR_WEEKLY_SCHEDULE,
  REMOVE_DOCTOR_WEEKLY_SCHEDULE_FAILURE,
  SAVE_DOCTOR_WEEKLY_SCHEDULE_LOADING,
  SAVE_DOCTOR_WEEKLY_SCHEDULE,
  SAVE_DOCTOR_WEEKLY_SCHEDULE_FAILURE,
  UPDATE_DOCTOR_WEEKLY_SCHEDULE_TIMEZONE_LOADING,
  UPDATE_DOCTOR_WEEKLY_SCHEDULE_TIMEZONE,
  UPDATE_DOCTOR_WEEKLY_SCHEDULE_TIMEZONE_FAILURE,
  FETCHING_DOCTOR_INTEGRATED_CALENDAR,
  DOCTOR_INTEGRATED_CALENDAR_IS_FETCHED,
  FAILED_TO_FETCH_DOCTOR_INTEGRATED_CALENDAR,

  FETCHING_REPORTS,
  REPORTS_ARE_FETCHED,
  FAILED_TO_FETCH_REPORTS,
  CLEAR_REPORTS,

  FETCHING_DOSESPOT_URL,
  DOSESPOT_URL_IS_FETCHED,
  FAILED_TO_DOSESPOT_URL,
  CLEAR_DOSESPOT_URL,
} from "../reducerConstants";
import {
  GET_MED_HISTORY,
  GET_MED_HISTORY_FAILURE,
} from "../reducerConstants";
import { CommonConstant } from '../../constants/common.constant';
import * as API from "../../utils/api";
import { makeApiCall } from "../../utils/customUtils";

export function ResetAppState(data) {
  return {
    type: RESET_APP_STATE,
    data: {},
  };
}

export function ToggleModal(data) {
  return {
    type: TOGGLE_MODAL,
    data,
  };
}

export function ResetNotesTab(data) {
  return {
    type: RESET_NOTES_TAB,
    data,
  };
}

export function ResetEmailTab(data) {
  return {
    type: RESET_EMAIL_TAB,
    data,
  };
}

export function ResetTextPatientDetails(data) {
  return {
    type: RESET_TEXT_PATIENT,
    data,
  };
}

export function ResetHistoryTab(data) {
  return {
    type: RESET_HISTROY_TAB,
    data,
  };
}

export function SetDenialAndSendValue(data) {
  return {
    type: SET_DENIAL_AND_SEND_EMAIL,
    data,
  };
}

export function SetAddNoteValue(data) {
  return {
    type: SET_ADD_NOTE,
    data,
  };
}

export function SetAddSoapNoteValue(data) {
  return {
    type: SET_ADD_SOAP_NOTE,
    data,
  };
}

export function SetModalAlertOpen(data) {
  return {
    type: SET_MODAL_ALERT_OPEN,
    data,
  };
}

export function SetModalTwilioAlertOpen(data) {
  return {
    type: SET_MODAL_TWILIO_ALERT_OPEN,
    data,
  };
}

export function SetStartVisit(data) {
  return {
    type: SET_START_VISIT,
    data,
  };
}

export function ResetCallPatientDetails() {
  return {
    type: RESET_CALL_PATIENT_DETAILS,
  };
}

export function SetCallPatientDetails(data) {
  return {
    type: SET_CALL_PATIENT_DETAILS,
    data,
  };
}

export function GetTokenAndStartVist(data) {
  return async (dispatch) => {
    const url = `Rooms/GetToken`;
    const api = API.get(url, {}, dispatch);
    makeApiCall(dispatch, api, SET_START_VISIT, SET_START_VISIT_FALIURE);
  };
}

export function ClearEmailAndDenyData(data) {
  return {
    type: RESET_EMAIL_AND_DENY_DATA,
    data,
  };
}

export function ClearEmailPatientData(data) {
  return {
    type: RESET_EMAIL_PATIENT_DATA,
    data,
  };
}

export function ClearAddNoteData(data) {
  return {
    type: RESET_ADD_NOTE_DATA,
    data,
  };
}

export function ResetApproveAndMailData(data) {
  return {
    type: RESET_APPROVE_AND_MAIL_DATA,
    data,
  };
}

export function SetSelectedTab(data) {
  return {
    type: SET_SELECTED_TAB,
    data,
  };
}

export function ToggleProductChangeModal(data) {
  return {
    type: TOGGLE_PRODUCT_CHANGE_MODAL,
    data,
  };
}

export function ResetPatientInfo(data) {
  return {
    type: RESET_PATIENT_INFO,
    data,
  };
}

export function SetProductInfo(data) {
  return {
    type: SET_PRODUCT_INFO,
    data,
  };
}

export function SetApproveAndMailData(data) {
  return {
    type: SET_APPROVE_AND_MAIL_DATA,
    data,
  };
}

export function SetApproveAndMailMainData(data) {
  return {
    type: SET_APPROVE_AND_MAIL_MAIN_DATA,
    data,
  };
}

export function HandleGlobalValueChange(data) {
  return {
    type: HANDLE_GLOBAL_VALUE_CHANGE,
    data,
  };
}

export function ToggleErrorModal(data) {
  return {
    type: TOGGLE_ERROR_MODAL,
    data,
  };
}

export function ResetSendOrderToCS() {
  return {
    type: RESET_SEND_ORDER_TO_CS_DATA,
  };
}

export function SetSendOrderToCSData(data) {
  return {
    type: SET_SEND_ORDER_TO_CS_DATA,
    data,
  };
}

export function GetScheduleVisitsCards(data) {
  return async (dispatch) => {
    dispatch({ type: GET_SCHEDULE_VISITS_CARD_LOADING });
    const url = `Visit/Visits`;
    const api = API.get(url, {}, dispatch);
    makeApiCall(
      dispatch,
      api,
      GET_SCHEDULE_VISITS_CARD,
      GET_SCHEDULE_VISITS_CARD_FALIURE
    );
  };
}

export function GetScheduleVisitsLV(data) {
  return async (dispatch) => {
    dispatch({ type: GET_SCHEDULE_VISITS_CARD_LOADING });
    const url = `Visit/Visits_LV`;
    const api = API.get(url, {}, dispatch);
    return makeApiCall(
      dispatch,
      api,
      GET_SCHEDULE_VISITS_CARD,
      GET_SCHEDULE_VISITS_CARD_FALIURE
    );
  };
}

export function ClearScheduledVisitsApiStatus() {
  return {
    type: GET_SCHEDULE_VISITS_CARD_CLEAR_API_STATUS
  }
}

export function CallDetails(data) {
  return async (dispatch) => {
    const url = `Visit/StartCall`;
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, POST_CALL_DETAILS, POST_CALL_DETAILS_FALIURE);
  };
}

export function GetTextPatientTemplates(data) {
  return async (dispatch) => {
    const url = `Visit/TextPatientTemplateList/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_TEXT_PATIENT_TEMPLATE,
      GET_TEXT_PATIENT_TEMPLATE_FALIURE
    );
  };
}

export const ResetDoseSpot = () => ({ type: RESET_DOSESPOT_DATA });

export function GetDoseSpot(data = {}) {
  return async (dispatch) => {
    const { OrderId = "", ProductId = "" } = data;
    const url = `Visit/JumpStart/${OrderId}/${ProductId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_DOSESPOT_DATA, GET_DOSESPOT_DATA_FALIURE);
  };
}

export function GetDoseSpotV2(data = {}) {
  return async (dispatch) => {
    const { OrderId = "", ProductId = "" } = data;
    const url = `Visit/JumpStart/${OrderId}/${ProductId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, '', '');
  };
}

export function GetDoseSpotV3() {
  return async (dispatch) => {
    dispatch({ type: FETCHING_DOSESPOT_URL });
    const url = `Visit/get-ds-jump-start-url`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, DOSESPOT_URL_IS_FETCHED, FAILED_TO_DOSESPOT_URL, 'post');
  };
}

export const ResetDoseSpotV3 = () => ({ type: CLEAR_DOSESPOT_URL });

export function CheckDoseSpotErrors(data = {}) {
  return async (dispatch) => {
    let { OrderId = "" } = data;
    const url = `Visit/GetDoseSpotErrors/${OrderId}`;
    const api = API.get(url, {}, dispatch);
    makeApiCall(dispatch, api, CHECK_DOSESPOT, CHECK_DOSESPOT_FALIURE);
  };
}

export function DosespotGetPatientPrescriptionsByOrderRequest(data = {}) {
  return async (dispatch) => {
    dispatch({ type: ADD_DOSESPOT_PATIENT_PRESCRIPTION_LOADING });
    const url = `${CommonConstant.SCRIPTINGAGTR_URL}json/reply/DosespotGetPatientPrescriptionsByOrderRequest`;
    const api = API.post(url, { data }, dispatch, () => {}, true, true);
    return await makeApiCall(dispatch, api, ADD_DOSESPOT_PATIENT_PRESCRIPTION, ADD_DOSESPOT_PATIENT_PRESCRIPTION_FAILURE);
  };
};

export function ApproveAndMailSubmit(
  data,
  handleRouteChange,
  routePath,
  callStarted
) {
  return async (dispatch) => {
    const url = `Visit/ApproveOrder`;
    const api = API.put(url, { data }, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      APPROVE_AND_MAIL_SUBMIT,
      APPROVE_AND_MAIL_SUBMIT_FALIURE
    ).then((_) => {
      let error = _ && _.data && _.data.Error;
      if (!error) {
        if (!callStarted) {
          handleRouteChange &&
            handleRouteChange(void 0, routePath === "pendingFilesCard" ? 1 : 0);
        }
      }
      return _;
    });
  };
}

export function CompleteVisitAndSendEmail(data) {
  return async (dispatch) => {
    const url = `Visit/CompleteVisit`;
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      APPROVE_AND_MAIL_SUBMIT,
      APPROVE_AND_MAIL_SUBMIT_FALIURE
    );
  };
}

export function VerifyPIN({ PIN = '' }) {
  return async (dispatch) => {
    const url = `Visit/VerifyPIN/${PIN}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, VERIFY_PIN, VERIFY_PIN_FALIURE);
  };
}

export function OnApproveAndMailClick(data) {
  return async (dispatch) => {
    const {
      approvedata,
      IsAlternateRx,
      handleRouteChange,
      routePath,
      callStarted,
      approvedata: { OrderId, PrescriptionData = [] } = {},
    } = data;
    const { ProductId } = PrescriptionData[0];
    const url = `Visit/VerifyPIN/${data.PIN}`;
    const api = API.get(url, {}, dispatch);
    const response = await makeApiCall(dispatch, api, VERIFY_PIN, VERIFY_PIN_FALIURE);
    const { data: { Data = '' } = {} } = response;

    if (Data !== 'Valid PIN') {
      return {};
    }

    if (IsAlternateRx) {
      GetDoseSpot({ OrderId, ProductId })(dispatch);
    } else {
      ApproveAndMailSubmit(
        approvedata,
        handleRouteChange,
        routePath,
        callStarted
      )(dispatch);
    }
  };
}

export function GetPendingFilesCards(data) {
  return async (dispatch) => {
    dispatch({ type: GET_PENDING_FILES_CARD_LOADING });
    const url = `Visit/PendingFiles`;
    const api = API.get(url, {}, dispatch);
    makeApiCall(
      dispatch,
      api,
      GET_PENDING_FILES_CARD,
      GET_PENDING_FILES_CARD_FALIURE
    );
  };
}

export function GetPendingFilesLV() {
  return async (dispatch) => {
    dispatch({ type: GET_PENDING_FILES_CARD_LOADING });
    const url = `Visit/PendingFiles_LV`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_PENDING_FILES_CARD,
      GET_PENDING_FILES_CARD_FALIURE
    );
  };
}

export function ClearPendingFilesApiStatus() {
  return {
    type: GET_PENDING_FILES_CARD_CLEAR_API_STATUS
  }
}

export const RemoveOrdersFromLV = ({ orderIds = [] }) => ({
  type: REMOVE_ORDERS_FROM_LV,
  data: { orderIds },
});

export function GetPatientInfo(data) {
  return async (dispatch) => {
    dispatch({ type: GET_PATIENT_INFO_LOADING });
    const url = `Visit/PatientDetails/${data.UserId}/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_PATIENT_INFO, GET_PATIENT_INFO_FALIURE);
  };
}

export function GetSoapNoteInfo(data) {
  return async (dispatch) => {
    const url = `Visit/CheckSoapNoteAdded/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_SOAP_NOTE_INFO);
  };
}

export function GetOrderNotes(data) {
  return async (dispatch) => {
    dispatch({ type: GET_ORDER_NOTES_LOADING });
    const url = `Visit/OrderNotesForOrder/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_ORDER_NOTES, GET_ORDER_NOTES_FAILURE);
  };
}

export function GetPatientNotes(data) {
  return async (dispatch) => {
    dispatch({ type: GET_PATIENT_NOTES_LOADING });
    const url = `Visit/PatientNotesForOrder/${data.UserId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_PATIENT_NOTES, GET_PATIENT_NOTES_FAILURE);
  };
}

export function GetMedicalOrderNotes(data) {
  return async (dispatch) => {
    dispatch({ type: GET_MEDICAL_ORDER_NOTES_LOADING });
    const url = `Visit/MedicalNotesForOrder/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_MEDICAL_ORDER_NOTES, GET_MEDICAL_ORDER_NOTES_FAILURE);
  };
}

export function GetMedicalPatientNotes(data) {
  return async (dispatch) => {
    dispatch({ type: GET_MEDICAL_PATIENT_NOTES_LOADING });
    const url = `Visit/MedicalNotesForPatient/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_MEDICAL_PATIENT_NOTES, GET_MEDICAL_PATIENT_NOTES_FAILURE);
  };
}

export function GetEmail(data) {
  return async (dispatch) => {
    dispatch({ type: GET_EMAIL_LOADING });
    const url = `Visit/EmailMessages/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_EMAIL, GET_EMAIL_FALIURE);
  };
}

export function GetHistory(data) {
  return async (dispatch) => {
    dispatch({ type: GET_HISTORY_LOADING });
    const url = `Visit/OrderHistory/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_HISTORY, GET_HISTORY_FALIURE);
  };
}

export function GetEmailTemplate(data) {
  return async (dispatch) => {
    const url = `Visit/EmailTemplateList/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_EMAIL_TEMPLATE, GET_EMAIL_TEMPLATE_FALIURE);
  };
}

export function GetEmailTemplateFromSalesforce(data = {
  productIds: [''],
  storefrontId: 0,
  action: '',
  orderId: 0,
}) {
  return async (dispatch) => {
    dispatch({ type: GET_EMAIL_TEMPLATE_V2_LOADING });
    const url = 'Visit/get-sf-email-templates-list';
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, GET_EMAIL_TEMPLATE_V2, GET_EMAIL_TEMPLATE_V2_FAILURE);
  };
}

export function GetApproveEmailTemplatesFromSalesforce(data = {
  productIds: [''],
  storefrontId: 0,
  action: '',
  orderId: 0,
}) {
  return async (dispatch) => {
    dispatch({ type: GET_APPROVE_EMAIL_TEMPLATE_V2_LOADING });
    const url = 'Visit/get-sf-email-templates-list';
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, GET_APPROVE_EMAIL_TEMPLATE_V2, GET_APPROVE_EMAIL_TEMPLATE_V2_FAILURE);
  };
}

export function GetDenyEmailTemplatesFromSalesforce(data = {
  productIds: [''],
  storefrontId: 0,
  action: '',
  orderId: 0,
}) {
  return async (dispatch) => {
    dispatch({ type: GET_DENY_EMAIL_TEMPLATE_V2_LOADING });
    const url = 'Visit/get-sf-email-templates-list';
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, GET_DENY_EMAIL_TEMPLATE_V2, GET_DENY_EMAIL_TEMPLATE_V2_FAILURE);
  };
}

export function GetScheduleEmailTemplatesFromSalesforce(data = {
  productIds: [''],
  storefrontId: 0,
  action: '',
  orderId: 0,
}) {
  return async (dispatch) => {
    dispatch({ type: GET_SCHEDULE_EMAIL_TEMPLATE_V2_LOADING });
    const url = 'Visit/get-sf-email-templates-list';
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, GET_SCHEDULE_EMAIL_TEMPLATE_V2, GET_SCHEDULE_EMAIL_TEMPLATE_V2_FAILURE);
  };
}

export function GetSubjectAndMailFromSalesforce(data = {}) {
  return async (dispatch) => {
    dispatch({ type: GET_SUB_AND_EMAIL_V2, data });
    return {};
  };
}

export function GetSubjectAndMail(data, id) {
  return async (dispatch) => {
    const url = `Visit/EmailTemplateMessage/${data.OrderId}/${id}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_SUB_AND_EMAIL, GET_SUB_AND_EMAIL_FALIURE);
  };
}

export function GetSubjectAndMailForAllTemplates({
  OrderId,
  Templates
}) {
  return async (dispatch) => {
    return new Promise(async (resolve = () => {}) => {
      dispatch({ type: GET_ALL_SUB_AND_EMAIL_LOADING });

      const promises = Templates.map(({ EmailMessageId: id }) => {
        const url = `Visit/EmailTemplateMessage/${OrderId}/${id}`;
        const api = API.get(url, {}, dispatch);
        return makeApiCall(dispatch, api, ALL_SUB_AND_EMAIL_RESPONSE, ALL_SUB_AND_EMAIL_ERROR);
      });

      const emailCollection = new Map();
      try {
        const responses = await Promise.all(promises);
        for (let i = 0; i < responses.length; i++) {
          const { EmailMessageId: id } = Templates[i];
          const response = responses[i];
          const subject = response.data.Data || {};
          emailCollection.set(id, subject);
        }
        dispatch({ type: GET_ALL_SUB_AND_EMAIL, data: emailCollection });
        resolve(emailCollection);
      } catch (e) {
        dispatch({ type: GET_ALL_SUB_AND_EMAIL_FAILURE });
        resolve(emailCollection);
      }
    });
  };
}

export function ResetSubjectAndMailFromSalesforce(data = {
  pId: -1,
}) {
  return async (dispatch) => {
    dispatch({ type: RESET_SUB_AND_EMAIL_V2, data });
    return {};
  };
}

export function GetApproveAndEmailPrepInfo(data) {
  return async (dispatch) => {
    dispatch({ type: GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_LOADING });
    const url = `Visit/PrescriptionDetails/${data.PaitentId}/${data.OrderId}${data.productString}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_APPROVE_AND_EMAIL_PRESCRIER_INFO,
      GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_FAILURE
    );
  };
}

export const ResetApproveAndEmailPrepInfo = () => ({
  type: RESET_APPROVE_AND_EMAIL_PRESCRIER_INFO,
});

export function GetOrderAndPrescriberFlags(data) {
  return async (dispatch) => {
    dispatch({ type: GET_ORDER_AND_PRESCRIBER_FLAGS_LOADING });
    const url = `Visit/OrderAndPrescriberFlags/${data.OrderId}${data.productString}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_ORDER_AND_PRESCRIBER_FLAGS,
      GET_ORDER_AND_PRESCRIBER_FLAGS_FAILURE
    );
  };
}

export function ResetOrderAndPrescriberFlags() {
  return { type: RESET_ORDER_AND_PRESCRIBER_FLAGS };
}

export function GetDenialReasons() {
  return async (dispatch) => {
    const url = `Visit/DenialReasonList`;
    const api = API.get(url, {}, dispatch);
    makeApiCall(dispatch, api, GET_DENIAL_REASON, GET_DENIAL_REASON_FAILURE);
  };
}

export function GetPatientMedicalNecessityPDFData({ OrderId = 0, PaitentId = 0, template = '' }) {
  return async (dispatch) => {
    const url = `Visit/PatientMedicalNecessityPDFData/${OrderId}/${PaitentId}?template=${template}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_PDF_DATA, GET_PDF_DATA_FALIURE);
  };
}

export function SetCmnTemplateFormField(data = {}) {
  return { data, type: SET_CMN_TEMPLATE_FORM_FIELD };
}

function generateProductInfo(Data = {}, Error = '', Message = '') {
  return {
    data: { Data, Error, Message }
  };
}

export function GetProductInfo({ OrderId = 0 }) {
  return async (dispatch) => {
    dispatch({ type: GET_PRODUCT_INFO_LOADING });
    const url = `Visit/ProductInformation/${OrderId}`;
    const api = API.get(url, {}, dispatch);
    const _ = await makeApiCall(dispatch, api, GET_PRODUCT_INFO, GET_PRODUCT_INFO_FALIURE)
    const error = _ && _.data && _.data.Error;
    if (!error) {
      const { data: { Data: { Product = [] } = {} } = {} } = _ || {};
      const product = Product.length ? Product[0] : {};
      const isAlternateRx = !!product.IsAlternateRx;

      if (isAlternateRx) {
        CheckDoseSpotErrors && CheckDoseSpotErrors({ OrderId })(dispatch);
      }
      return generateProductInfo({
        product,
        orderId: OrderId
      });
    }
    return generateProductInfo({
      product: {},
      orderId: OrderId
    });
  };
}

export function GetProductInfoV2({ OrderId = 0 }, options = { optionalFunc: undefined, NoLoader: false }) {
  return async (dispatch) => {
    dispatch({ type: GET_PRODUCT_INFO_LOADING });
    const url = `Visit/ProductInformation/${OrderId}`;
    const api = API.get(url, {}, dispatch, options.optionalFunc, options.NoLoader, false);
    return await makeApiCall(dispatch, api, GET_PRODUCT_INFO, GET_PRODUCT_INFO_FALIURE);
  };
}

export const ResetProductInfoV2 = () => ({
  type: RESET_PRODUCT_INFO,
});

export function GetProductInfoV3({ OrderId = 0 }) {
  return async (dispatch) => {
    dispatch({ type: GET_PRODUCT_INFO_V3_LOADING, request: { OrderId, } });
    const url = `Visit/ProductInformation/${OrderId}`;
    const api = API.get(url, {}, dispatch, null, true);
    return await makeApiCall(dispatch, api, GET_PRODUCT_INFO_V3, GET_PRODUCT_INFO_V3_FAILURE);
  };
}

export function ClearProductInfoV3() {
  return { type: CLEAR_PRODUCT_INFO_V3 };
}

export function GetConsultQuestions(data) {
  return async (dispatch) => {
    dispatch({ type: GET_CONSULT_QUESTION_LOADING });
    const url = `Visit/ConsultWithFlags/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_CONSULT_QUESTION,
      GET_CONSULT_QUESTION_FALIURE
    );
  };
}

export function ValidateToken() {
  return async (dispatch) => {
    const url = `${CommonConstant.LOGIN_URL}api/v1/Authentication/ValidateToken`;
    const api = API.get(url, {}, dispatch, undefined, true, true);
    return await makeApiCall(dispatch, api, VALIDATE_TOKEN, VALIDATE_TOKEN_FAILURE);
  };
}

export function LogOff(data) {
  return async (dispatch) => {
    const url = `authserver/api/Authentication/LogOFF`;
    const api = API._delete(url, {}, dispatch);
    return await makeApiCall(dispatch, api, LOG_OFF, LOG_OFF_FALIURE);
  };
}

export function GetProductList(data) {
  return async (dispatch) => {
    const url = `Visit/ProductListFromSameBaseGroup/${data.OrderId}/${data.ProductId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_PRODUCT_LIST, GET_PRODUCT_LIST_FALIURE);
  };
}

export function GetChangeProductList({
  OrderId = '',
  ProductIds = []
}) {
  return async (dispatch) => {
    return new Promise(async (resolve = () => {}) => {
      dispatch({ type: GET_CHANGE_PRODUCT_LIST_LOADING });
      const promises = ProductIds.map((pId) => {
        const url = `Visit/ProductListFromSameBaseGroup/${OrderId}/${pId}`;
        const api = API.get(url, {}, dispatch);
        return makeApiCall(dispatch, api, CHANGE_PRODUCT_LIST_RESPONSE, CHANGE_PRODUCT_LIST_ERROR);
      });

      const productCollection = new Map();
      try {
        const responses = await Promise.all(promises);
        for (let i = 0; i < responses.length; i++) {
          const productId = ProductIds[i];
          const response = responses[i];
          const changeProducts = response?.data?.Data?.ProductItem || [];
          productCollection.set(productId, changeProducts);
        }
        dispatch({ type: GET_CHANGE_PRODUCT_LIST, data: productCollection });
        resolve(productCollection);
      } catch (e) {
        dispatch({ type: GET_CHANGE_PRODUCT_LIST_FAILURE });
        resolve(productCollection);
      }
    });
  };
}

export function ResetChangeProductList() {
  return { type: RESET_CHANGE_PRODUCT_LIST };
}

export function GetQtyByProduct(data) {
  return async (dispatch) => {
    dispatch({ type: GET_QTY_BY_PRODUCT_ID_LOADING });
    const url = `Visit/QuantityRangeForProduct/${data.OrderId}/${data.ProductId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_QTY_BY_PRODUCT_ID,
      GET_QTY_BY_PRODUCT_ID_FALIURE
    );
  };
}

export function SaveProductChanges(data) {
  return async (dispatch) => {
    let { UserId, OrderId, DoctorId, routePath } = data;
    delete data.UserId;
    delete data.routePath;
    const url = `Visit/ChangeProductForOrder`;
    const api = API.put(
      url,
      { data },
      dispatch,
      callGetProductInfo({ UserId, OrderId, DoctorId })
    );
    return await makeApiCall(
      dispatch,
      api,
      SAVE_PRODUCT_CHANGES,
      SAVE_PRODUCT_CHANGES_FALIURE
    ).then((_) => {
      let error = _ && _.data && _.data.Error;
      if (!error) {
        routePath === "pendingFilesCard"
          ? GetPendingFilesCards(data.DoctorId)(dispatch)
          : GetScheduleVisitsCards(data.DoctorId)(dispatch);

        const productInfo = { UserId, OrderId };
        GetMedicalOrderNotes(productInfo)(dispatch);
        GetMedicalPatientNotes(productInfo)(dispatch);
        GetOrderNotes(productInfo)(dispatch);
        GetPatientNotes(productInfo)(dispatch);
        GetConsultQuestions(productInfo)(dispatch);
      }

      const hideModalConfig = {
        value: false,
        type: 'commonModal',
        name: 'isProductChangeModalOpen',
      };
      dispatch(HandleGlobalValueChange(hideModalConfig));
    });
  };
}

export function ChangeProductForOrder(data = {}) {
  return async (dispatch) => {
    dispatch({ type: SAVE_PRODUCT_CHANGES_LOADING });
    const url = `Visit/ChangeProductForOrder`;
    const api = API.put(url, { data }, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      SAVE_PRODUCT_CHANGES,
      SAVE_PRODUCT_CHANGES_FALIURE,
    );
  };
}

export function DenialAndEmail(
  data,
  handleRouteChange,
  routePath,
  callStarted
) {
  return async (dispatch) => {
    const url = `Visit/DenyOrder`;
    const api = API.put(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, DENIAL_AND_EMAIL, DENIAL_AND_EMAIL_FALIURE).then(
      (_) => {
        let error = _ && _.data && _.data.Error;
        if (!error) {
          if (!callStarted) {
            handleRouteChange &&
              handleRouteChange(
                void 0,
                routePath === "pendingFilesCard" ? 1 : 0
              );
          }
        }
        return _;
      }
    ).catch((e) => e);
  };
}

export function AddNote(data) {
  return async (dispatch) => {
    const url = `Visit/AddNote`;
    const api = API.put(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, ADD_NOTE, ADD_NOTE_FAILURE);
  };
}

export function GetSoapNoteTemplates(data = { productIds: [] }) {
  return async (dispatch) => {
    dispatch({ type: GET_SOAP_NOTE_TEMPLATES_LOADING });
    const url = `Visit/soap-note-template-list`;
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, GET_SOAP_NOTE_TEMPLATES, GET_SOAP_NOTE_TEMPLATES_FAILURE);
  };
}

export function SetSoapNoteTemplate(data = {}) {
  return { data, type: SET_SOAP_NOTE_TEMPLATE };
}

export function AddSoapNote(data) {
  return async (dispatch) => {
    const url = `Visit/AddSoapNote`;
    const api = API.put(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, ADD_SOAP_NOTE, ADD_NOTE_FAILURE);
  };
}

const callGetProductInfo = (id) => {
  return async (dispatch) => GetProductInfo(id)(dispatch);
};

export function GetHeaderInfo() {
  return async (dispatch) => {
    dispatch({ type: GET_HEADER_INFO_LOADING });
    const url = `Visit/WelcomeMessage`;
    const api = API.get(url, {}, dispatch);
    makeApiCall(dispatch, api, GET_HEADER_INFO, GET_HEADER_INFO_FALIURE);
  };
}

export function GetNotes(data) {
  return async (dispatch) => {
    const url = `Visit/OrderNotes/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_NOTES, GET_NOTES_FALIURE);
  };
}

export function GetNotesV2({ OrderId = 0 }) {
  return async (dispatch) => {
    const url = `Visit/OrderNotes/${OrderId}`;
    return await API.get(url, {}, dispatch);
  };
}

export function GetSendOrderToCSReasons() {
  return async (dispatch) => {
    const url = `Visit/SendToCSReasonList`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_REASONS, GET_REASONS_FALIURE);
  };
}

export function TextPatient(data) {
  return async (dispatch) => {
    dispatch({ type: TEXT_PATIENT_LOADING });
    const url = `Visit/SendTextToPatient`;
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, TEXT_PATIENT, TEXT_PATIENT_FALIURE);
  };
}

export function LogError(data) {
  return async (dispatch) => {
    const url = `Visit/LogUIException`;
    const api = API.post(url, { data }, dispatch);
    makeApiCall(dispatch, api, LOG_ERROR, LOG_ERROR_FALIURE, "post");
  };
}

export function SendOrderToCS(data, handleRouteChange, routePath, callStarted) {
  return async (dispatch) => {
    const url = `Visit/SendOrderToCS`;
    const api = API.put(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, SEND_ORDER_TO_CS, SEND_ORDER_TO_CS_FALIURE).then(
      (_) => {
        let error = _ && _.data && _.data.Error;
        if (!error) {
          if (!callStarted) {
            handleRouteChange &&
              handleRouteChange(
                void 0,
                routePath === "pendingFilesCard" ? 1 : 0
              );
          }
        }
        return _;
      }
    ).catch((e) => e);
  };
}

export function GetCallPatientDetails(data) {
  return async (dispatch) => {
    const url = `Visit/CallPatientModalData/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_CALL_PATIENT_DETAILS,
      GET_CALL_PATIENT_DETAILS_FAILURE
    );
  };
}

export function CallEnd(data) {
  return async (dispatch) => {
    const url = `Rooms/CompleteARoom/${data}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, CALL_END, CALL_END_FAILURE);
  };
}

export function OrderCallSummaryReasons(data) {
  return async (dispatch) => {
    const url = `Visit/OrderCallSummaryReasons`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, CALL_SUMMARY_REASONS, CALL_SUMMARY_REASONS_FAILURE);
  };
}

export function CallToPatient(data) {
  return async (dispatch) => {
    const url = `Visit/CallToPatient/${data.DoctorNumber}/${data.StoreFrontNumber}/${data.StorefrontName}/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, CALL_PATIENT, CALL_PATIENT_FAILURE);
  };
}

export function CallToPatientPhys(data) {
  return async (dispatch) => {
    dispatch({ type: CALL_PATIENT_LOADING });
    const url = `Visit/CallToPatientPhys/${data.DoctorNumber}/${data.StoreFrontNumber}/${data.StorefrontName}/${data.OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, CALL_PATIENT, CALL_PATIENT_FAILURE);
  };
}

export function InsertCallSummary(data = {}) {
  return async (dispatch) => {
    const url = `Visit/InsertCallSummary`;
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, INSERT_CALL_SUMMARY, INSERT_CALL_SUMMARY_FAILURE);
  };
}

export function EmailPatientDetails(data) {
  return async (dispatch) => {
    dispatch({ type: EMAIL_PATIENT_DATA_LOADING });
    const url = `Visit/SendEmailToPatient`;
    const api = API.put(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, EMAIL_PATIENT_DATA, EMAIL_PATIENT_DATA_FAILURE);
  };
}

export function GetUploadtInfo(data) {
  return async (dispatch) => {
    const url = `Visit/UploadedDocuments/${data.OrderId}/${data.QuestionId}`;
    const api = API.get(url, { data }, dispatch);
    makeApiCall(dispatch, api, UPLOAD_DOC_PATIENT, UPLOAD_DOC_PATIENT_FAILURE);
  };
}

export function SetUploadedDocs(data) {
  return {
    type: SET_UPLOAD_DOCS,
    data,
  };
}

export function GetPDFInfo(data) {
  return async (dispatch) => {
    const url = `Visit/GetPdf/${data.OrderId}`;
    const api = API.get(url, { data }, dispatch);
    makeApiCall(dispatch, api, PDF_DOC, PDF_DOC_FAILURE, "get", "test");
  };
}

export function SetUploadedPdfs(data) {
  return {
    type: SET_UPLOAD_PDFS,
    data,
  };
}

export function ClearSearchData(data) {
  return {
    type: CLEAR_SEARCH_DATA,
    data,
  };
}

export function CheckPdfExists(orderId) {
  return async (dispatch) => {
    dispatch({ type: PDF_AV_LOADING, data: { orderId } });
    const url = `Visit/GetPdf/${orderId}`;
    const api = API.get(url, { data: orderId }, dispatch);
    makeApiCall(dispatch, api, PDF_AV, PDF_NAV, 'get', 'test');
  };
}

export function SearchData(data = {}) {
  const {
    orderId = "",
    startDate = "",
    endDate = "",
    firstName = "",
    lastName = "",
  } = data;

  const queryParams = [];
  if (orderId?.length) {
    queryParams.push(`orderId=${orderId}`);
  }

  if (startDate?.length) {
    queryParams.push(`startDate=${startDate}`);
  }

  if (endDate?.length) {
    queryParams.push(`endDate=${endDate}`);
  }

  if (firstName?.length) {
    queryParams.push(`firstName=${firstName}`);
  }

  if (lastName?.length) {
    queryParams.push(`lastName=${lastName}`);
  }

  const queryString = queryParams.join('&');
  if (queryString.length === 0) {
    return { type: SET_SEARCH_ERROR, data };
  }

  return async (dispatch) => {
    dispatch({ type: SET_SEARCH_LOADING });
    const url = `searchOrders`;
    const api = API.get(url, { req: queryString }, dispatch);
    return await makeApiCall(dispatch, api, SET_SEARCH_DATA, SET_SEARCH_DATA_FAILURE);
  };
}

export function SetCallSummary(data = { value: -1 }) {
  return {
    type: SET_CALL_SUMMARY,
    data
  };
}

export function SetFilterBy(data = { target: '', value: '' }) {
  return {
    data,
    type: SET_FILTER_BY
  };
}

export function GetPatientUploads(data = { UserId: '' }) {
  return async (dispatch) => {
    dispatch({ type: GET_PATIENT_UPLOADS_LOADING });
    const url = `Visit/patient-documents-by-peopleId/${data.UserId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_PATIENT_UPLOADS, GET_PATIENT_UPLOADS_FAILURE);
  };
}

export function GetEmailReasons(data = {}) {
  return async (dispatch) => {
    dispatch({ type: GET_EMAIL_REASONS_LOADING });
    const url = `Visit/EmailReasonTemplateList`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(dispatch, api, GET_EMAIL_REASONS, GET_EMAIL_REASONS_FAILURE);
  };
}

export function GetProductCost(data = {}) {
  return async (dispatch) => {
    dispatch({ type: GET_PRODUCT_COST_LOADING });
    const url = `Visit/get-order-add-product-cost`;
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, GET_PRODUCT_COST, GET_PRODUCT_COST_FAILURE);
  };
}

export function ResetProductCost() {
  return { type: RESET_PRODUCT_COST };
}

export function AddProduct(data = {}) {
  return async (dispatch) => {
    dispatch({ type: ADD_PRODUCT_LOADING });
    const url = `Visit/add-new-product-to-orderitem`;
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, ADD_PRODUCT, ADD_PRODUCT_FAILURE);
  };
}

export function GetSavedFlags({ OrderId = 0 }) {
  return async (dispatch) => {
    dispatch({ type: GET_SAVED_FLAGS_LOADING });
    const url = `Visit/get-order-medical-flags/${OrderId}`;
    const api = API.get(url, {}, dispatch, undefined, true, false);
    return await makeApiCall(dispatch, api, GET_SAVED_FLAGS, GET_SAVED_FLAGS_FAILURE);
  };
}

export function SaveFlags(data = []) {
  return async (dispatch) => {
    dispatch({ type: SAVE_FLAGS_LOADING });
    const url = `Visit/save-order-medical-flags`;
    const api = API.post(url, { data }, dispatch, undefined, true, false);
    return await makeApiCall(dispatch, api, SAVE_FLAGS, SAVE_FLAGS_FAILURE);
  };
}

export function ResetSavedFlags() {
  return { type: RESET_SAVED_FLAGS };
}

export function SaveExtendedConsult(data) {
  return async (dispatch) => {
    dispatch({ type: SAVE_EXTENDED_CONSULT_LOADING });
    const url = `Visit/update-patient-medications`;
    const api = API.put(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, SAVE_EXTENDED_CONSULT, SAVE_EXTENDED_CONSULT_FAILURE);
  };
}

export function SendPasswordRecoveryOTP(data = { username: '' }) {
  return async (dispatch) => {
    dispatch({ type: SEND_PASSWORD_RECOVERY_OTP });
    const url = `Visit/SendSMSForgotPasswordRequest?username=${data.username}`;
    const api = API.post(url, { data: {} }, dispatch);
    return await makeApiCall(dispatch, api, SENT_PASSWORD_RECOVERY_OTP, FAILD_TO_SEND_PASSWORD_RECOVERY_OTP);
  };
}

export function ValidatePasswordRecoveryOTP(data = {
  alias: '',
  companyId: 0,
  uniqueCode: '',
  peopleId: 0,
}) {
  return async (dispatch) => {
    dispatch({ type: VALIDATE_PASSWORD_RECOVERY_OTP });
    const url = `Visit/ConfirmSMSForgotPasswordRequest`;
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, VALIDATED_PASSWORD_RECOVERY_OTP, FAILED_TO_VALIDATE_PASSWORD_RECOVERY_OTP);
  };
}

export function ResetPasswordUsingPasswordRecoveryOTP(data = {
  companyId: 0,
  password: '',
  passwordConfirm: '',
  uniqueCode: '',
}) {
  return async (dispatch) => {
    dispatch({ type: RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP });
    const url = `Visit/ResetPasswordCodeRequest`;
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, PASSWORD_IS_RESET_USING_PASSWORD_RECOVERY_OTP, FAILED_TO_RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP);
  };
}

export function ClearRecoverPassword() {
  return { type: CLEAR_RECOVER_PASSWORD };
}

export function GetTasks() {
  return async (dispatch) => {
    dispatch({ type: GET_TASKS_LOADING });
    const url = `Visit/HCPTask/GetHCPTask`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_TASKS,
      GET_TASKS_FAILURE,
    );
  };
}

export function GetTaskByOrderId({ OrderId }) {
  return async (dispatch) => {
    dispatch({ type: GET_TASK_BY_ORDER_ID_LOADING });
    const url = `Visit/HCPTask/GetHCPTask/${OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_TASK_BY_ORDER_ID,
      GET_TASK_BY_ORDER_ID_FAILURE,
    );
  };
}

export function UpdateTask(data = {}) {
  return async (dispatch) => {
    dispatch({ type: UPDATE_TASK_LOADING });
    const url = `Visit/HCPTask/UpdateTask`;
    const api = API.put(url, { data }, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      UPDATE_TASK,
      UPDATE_TASK_FAILURE,
    );
  };
}

export function GetICD10CodesByOrderId({ OrderId }) {
  return async (dispatch) => {
    dispatch({ type: GET_ICD10CODES_BY_ORDER_ID_LOADING });
    const url = `Visit/GetOrderClinicalCodes/${OrderId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_ICD10CODES_BY_ORDER_ID,
      GET_ICD10CODES_BY_ORDER_ID_FAILURE,
    );
  };
}

/**
 * @param {{
 *  code: string;
 * }} data 
 * @returns {void}
 */
export function RemoveICD10CodeFromCollection(data) {
  return async (dispatch) => {
    dispatch({ type: REMOVE_ICD10CODE_FROM_COLLECTION, data });
  };
}

export function GetICD10CodesByPatientId({ UserId }) {
  return async (dispatch) => {
    dispatch({ type: GET_ICD10CODES_BY_PATIENT_ID_LOADING });
    const url = `Visit/getpatienticd10codehistory/${UserId}`;
    const api = API.get(url, {}, dispatch);
    return await makeApiCall(
      dispatch,
      api,
      GET_ICD10CODES_BY_PATIENT_ID,
      GET_ICD10CODES_BY_PATIENT_ID_FAILURE,
    );
  };
}

export function GetICD10CodesByTerms({ terms, maxList }) {
  return async (dispatch) => {
    dispatch({ type: GET_ICD10CODES_BY_TERMS_LOADING });
    const url = `https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&maxList=${maxList}&terms=${terms}`;
    const api = API.get(url, {}, dispatch, undefined, true, true);
    return await makeApiCall(
      dispatch,
      api,
      GET_ICD10CODES_BY_TERMS,
      GET_ICD10CODES_BY_TERMS_FAILURE,
      "post",
    );
  };
}

export function ClearICD10CodesByTerms() {
  return async (dispatch) => {
    dispatch({ type: CLEAR_ICD10CODES_BY_TERMS });
  }
}

export function AddICD10Codes(data) {
  return async (dispatch) => {
    dispatch({ type: ADD_ICD10CODES_LOADING });
    const url = `Visit/save-update-clinical-code`;
    const api = API.post(url, { data }, dispatch, undefined, true, false);
    return await makeApiCall(
      dispatch,
      api,
      ADD_ICD10CODES,
      ADD_ICD10CODES_FAILURE,
      "post",
    );
  };
}

export function RemoveICD10Codes(data) {
  return async (dispatch) => {
    dispatch({ type: REMOVE_ICD10CODES_LOADING });
    const url = `Visit/delete-clinical-code`;
    const api = API.put(url, { data }, dispatch, undefined, true, false);
    return await makeApiCall(
      dispatch,
      api,
      REMOVE_ICD10CODES,
      REMOVE_ICD10CODES_FAILURE,
      "put",
    );
  };
}

export function ChangePassword(data) {
  return async (dispatch) => {
    dispatch({ type: CHANGE_PASSWORD_IN_PROGRESS });
    const url = `Visit/change-password`;
    const api = API.post(url, { data }, dispatch, undefined, true, false);
    return await makeApiCall(dispatch, api, PASSWORD_IS_CHANGED, FAILED_TO_CHANGE_PASSWORD, "post");
  };
}

/**
 * 
 * @param {{
 *  currentPIN: string;
 *  newPIN: string;
 * }} data 
 * @returns {Promise<{
 *  status: number;
 * }>}
 */
export function ChangePIN(data) {
  return async (dispatch) => {
    dispatch({ type: CHANGE_PIN_IN_PROGRESS });
    const url = `Visit/change-pin/${data?.currentPIN}/${data?.newPIN}`;
    const api = API.put(url, {}, dispatch, undefined, true, false);
    return await makeApiCall(dispatch, api, PIN_IS_CHANGED, FAILED_TO_CHANGE_PIN, "put");
  };
}

export function GetDoctorProfile() {
  return async (dispatch) => {
    dispatch({ type: FETCHING_DOCTOR_PROFILE });
    const url = `Visit/get-doctor-profile`;
    const api = API.get(url, {}, dispatch, undefined, true, false);
    return await makeApiCall(
      dispatch,
      api,
      DOCTOR_PROFILE_IS_FETCHED,
      FAILED_TO_FETCH_DOCTOR_PROFILE,
    );
  };
}

export function GetDoctorWeeklySchedule() {
  return async (dispatch) => {
    dispatch({ type: FETCHING_DOCTOR_WEEKLY_SCHEDULE });
    const url = `Visit/get-doctor-weekly-schedule`;
    const api = API.get(url, {}, dispatch, undefined, true, false);
    return await makeApiCall(
      dispatch,
      api,
      DOCTOR_WEEKLY_SCHEDULE_IS_FETCHED,
      FAILED_TO_FETCH_DOCTOR_WEEKLY_SCHEDULE,
    );
  };
}

export function SetDoctorWeeklyScheduleData(data = {}) {
  return {
    type: SET_DOCTOR_WEEKLY_SCHEDULE_DATA,
    data,
  };
}

export function UpdateDoctorWeeklySchedule(data = {}) {
  return async (dispatch) => {
    dispatch({ type: UPDATE_DOCTOR_WEEKLY_SCHEDULE_LOADING });
    const url = `Visit/update-weekly-schedule`;
    const api = API.post(url, { data }, dispatch, undefined, true, false);
    return await makeApiCall(
      dispatch,
      api,
      UPDATE_DOCTOR_WEEKLY_SCHEDULE,
      UPDATE_DOCTOR_WEEKLY_SCHEDULE_FAILURE,
      'post',
    );
  };
}

export function RemoveDoctorWeeklySchedule(data = {}) {
  return async (dispatch) => {
    dispatch({ type: REMOVE_DOCTOR_WEEKLY_SCHEDULE_LOADING });
    const url = `Visit/remove-weekly-schedule`;
    const api = API.post(url, { data }, dispatch, undefined, true, false);
    return await makeApiCall(
      dispatch,
      api,
      REMOVE_DOCTOR_WEEKLY_SCHEDULE,
      REMOVE_DOCTOR_WEEKLY_SCHEDULE_FAILURE,
      'post',
    );
  };
}

export function SaveDoctorWeeklySchedule(data = {}) {
  return async (dispatch) => {
    dispatch({ type: SAVE_DOCTOR_WEEKLY_SCHEDULE_LOADING });
    const url = `Visit/save-weekly-schedule`;
    const api = API.post(url, { data }, dispatch, undefined, true, false);
    return await makeApiCall(
      dispatch,
      api,
      SAVE_DOCTOR_WEEKLY_SCHEDULE,
      SAVE_DOCTOR_WEEKLY_SCHEDULE_FAILURE,
      'post',
    );
  };
}

export function UpdateDoctorWeeklyScheduleTimezone(data = {}) {
  return async (dispatch) => {
    const { timezone = '', updatedBy = 0 } = data;
    dispatch({ type: UPDATE_DOCTOR_WEEKLY_SCHEDULE_TIMEZONE_LOADING });
    const encodedTimezone = encodeURIComponent(timezone);
    const url = `Visit/update-weekly-schedule_timezone?timezone=${encodedTimezone}&updatedBy=${updatedBy}`;
    const api = API.post(url, {}, dispatch, undefined, true, false);
    return await makeApiCall(
      dispatch,
      api,
      UPDATE_DOCTOR_WEEKLY_SCHEDULE_TIMEZONE,
      UPDATE_DOCTOR_WEEKLY_SCHEDULE_TIMEZONE_FAILURE,
      'post',
    );
  };
}

export function GetDoctorIntegratedCalendar() {
  return async (dispatch) => {
    dispatch({ type: FETCHING_DOCTOR_INTEGRATED_CALENDAR });
    const url = `Visit/get-doctor-integrated-calendar`;
    const api = API.get(url, {}, dispatch, undefined, true, false);
    return await makeApiCall(
      dispatch,
      api,
      DOCTOR_INTEGRATED_CALENDAR_IS_FETCHED,
      FAILED_TO_FETCH_DOCTOR_INTEGRATED_CALENDAR,
    );
  };
}

/**
 * 
 * @param {{
 *  startDate: string;
 *  endDate: string;
 * }} data 
 * @returns {Promise<{
 *  status: number;
 * }>}
 */
export function GetReports(data) {
  return async (dispatch) => {
    dispatch({ type: FETCHING_REPORTS });
    const url = `Visit/get-doctor-visit-report`;
    const api = API.post(url, { data }, dispatch, undefined, true, false);
    return await makeApiCall(
      dispatch,
      api,
      REPORTS_ARE_FETCHED,
      FAILED_TO_FETCH_REPORTS,
      'post',
    );
  };
}

export function ClearReports() {
  return async (dispatch) => {
    dispatch({ type: CLEAR_REPORTS });
  };
}

export function ScheduleVisit(data) {
  return async (dispatch) => {
    dispatch({ type: SCHEDULE_VISIT_LOADING });
    const url = `Visit/update-product-modality`;
    const api = API.post(url, { data }, dispatch);
    return await makeApiCall(dispatch, api, SCHEDULE_VISIT, SCHEDULE_VISIT_FAILURE);
  };
}

export function ResetScheduleVisit() {
  return async (dispatch) => {
    dispatch({ type: REEST_SCHEDULE_VISIT });
  };
}
export function GetMedHistory(data = {}) {
  return async (dispatch) => {
    const { orderId, doctorId, productId } = data;
    const url = `${CommonConstant.SCRIPTINGAGTR_URL}DoseSpot/MedicationHistory/GetAll/WithConsent/${orderId}/${doctorId}/${productId}`;
    const api = API.get(url, {}, dispatch, undefined, false, true);
    const response = await makeApiCall(dispatch, api, GET_MED_HISTORY, GET_MED_HISTORY_FAILURE);
    return { data: response?.data || [] };
  };
}

